import React from 'react';

const NoDataShown = () => {
  return (
    <div className="flex flex-col justify-center w-full items-center pb-28">
      <svg
        className="w-80 h-72"
        width="1062"
        height="870"
        viewBox="0 0 1062 870"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="No Results">
          <g id="circle">
            <path
              id="Stroke 1"
              d="M35.5342 399V408"
              stroke="#D2D8DF"
              strokeWidth="2.921"
              strokeLinecap="round"
            />
            <g id="Group 8">
              <path
                id="Stroke 2"
                d="M15.3223 403.875L22.6766 411.446"
                stroke="#D2D8DF"
                strokeWidth="2.921"
                strokeLinecap="round"
              />
              <path
                id="Stroke 4"
                d="M6.7207 424.028H17.1196"
                stroke="#D2D8DF"
                strokeWidth="2.921"
                strokeLinecap="round"
              />
              <path
                id="Stroke 6"
                d="M14.4814 444.539L21.8357 436.969"
                stroke="#D2D8DF"
                strokeWidth="2.921"
                strokeLinecap="round"
              />
            </g>
            <path
              id="Stroke 9"
              d="M35.5342 447V438"
              stroke="#D2D8DF"
              strokeWidth="2.921"
              strokeLinecap="round"
            />
            <path
              id="Stroke 10"
              d="M50.5342 441L44.5342 435"
              stroke="#D2D8DF"
              strokeWidth="2.921"
              strokeLinecap="round"
            />
            <path
              id="Stroke 11"
              d="M62.5342 426H53.5342"
              stroke="#D2D8DF"
              strokeWidth="2.921"
              strokeLinecap="round"
            />
            <path
              id="Stroke 12"
              d="M56.5342 405L50.5342 411"
              stroke="#D2D8DF"
              strokeWidth="2.921"
              strokeLinecap="round"
            />
            <path
              id="Stroke 13"
              d="M518.534 6V12"
              stroke="#D2D8DF"
              strokeWidth="2.921"
              strokeLinecap="round"
            />
            <path
              id="Stroke 15"
              d="M500.534 24H506.534"
              stroke="#D2D8DF"
              strokeWidth="2.921"
              strokeLinecap="round"
            />
            <path
              id="Stroke 16"
              d="M518.534 42V36"
              stroke="#D2D8DF"
              strokeWidth="2.921"
              strokeLinecap="round"
            />
            <path
              id="Stroke 17"
              d="M533.534 24H527.534"
              stroke="#D2D8DF"
              strokeWidth="2.921"
              strokeLinecap="round"
            />
            <path
              id="Stroke 18"
              d="M170.534 258V267"
              stroke="#D2D8DF"
              strokeWidth="2.921"
              strokeLinecap="round"
            />
            <path
              id="Stroke 19"
              d="M143.534 285H152.534"
              stroke="#D2D8DF"
              strokeWidth="2.921"
              strokeLinecap="round"
            />
            <path
              id="Stroke 20"
              d="M170.534 309V300"
              stroke="#D2D8DF"
              strokeWidth="2.921"
              strokeLinecap="round"
            />
            <path
              id="Stroke 21"
              d="M194.534 285H185.534"
              stroke="#D2D8DF"
              strokeWidth="2.921"
              strokeLinecap="round"
            />
            <g id="Group 42">
              <path
                id="Stroke 22"
                d="M816.298 585.118C823.468 585.118 829.282 590.934 829.282 598.105C829.282 605.279 823.468 611.092 816.298 611.092C809.129 611.092 803.314 605.279 803.314 598.105"
                stroke="#D2D8DF"
                strokeWidth="2.921"
                strokeLinecap="round"
              />
              <path
                id="Fill 26"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M875.722 467.291C883.431 464.886 895.249 455.457 897.984 445.313C900.465 454.28 910.863 464.886 920.246 465.688C909.684 469.428 899.586 480.538 897.984 489.266C896.894 480.37 882.927 468.587 875.722 467.291Z"
                fill="#EBECEE"
              />
              <path
                id="Fill 28"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M84.3545 581.117C88.2105 579.914 94.1167 575.201 95.4843 570.129C96.7247 574.61 101.923 579.914 106.614 580.317C101.335 582.184 96.2866 587.74 95.4843 592.104C94.9393 587.656 87.9558 581.764 84.3545 581.117Z"
                fill="#EBECEE"
              />
              <path
                id="Fill 30"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M155.912 163.791C155.912 169.355 151.404 173.862 145.844 173.862C140.282 173.862 135.776 169.355 135.776 163.791C135.776 158.23 140.282 153.721 145.844 153.721C151.404 153.721 155.912 158.23 155.912 163.791Z"
                fill="#D1D8DF"
              />
              <path
                id="Fill 32"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M828.194 190.832C828.194 200.128 820.658 207.664 811.367 207.664C802.071 207.664 794.537 200.128 794.537 190.832C794.537 181.536 802.071 174 811.367 174C820.658 174 828.194 181.536 828.194 190.832Z"
                fill="#EBECEE"
              />
              <path
                id="Fill 34"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1061.28 145.229C1061.28 152.604 1055.31 158.581 1047.94 158.581C1040.56 158.581 1034.59 152.604 1034.59 145.229C1034.59 137.854 1040.56 131.877 1047.94 131.877C1055.31 131.877 1061.28 137.854 1061.28 145.229Z"
                fill="#EBECEE"
              />
              <path
                id="Stroke 36"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M344.067 768.803C344.067 773.452 340.301 777.22 335.653 777.22C331.007 777.22 327.24 773.452 327.24 768.803C327.24 764.154 331.007 760.386 335.653 760.386C340.301 760.386 344.067 764.154 344.067 768.803Z"
                stroke="#D2D8DF"
                strokeWidth="2.921"
                strokeLinecap="round"
              />
              <path
                id="Stroke 38"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M339.061 99.0952C339.061 104.659 334.553 109.166 328.994 109.166C323.434 109.166 318.926 104.659 318.926 99.0952C318.926 93.5339 323.434 89.0248 328.994 89.0248C334.553 89.0248 339.061 93.5339 339.061 99.0952Z"
                stroke="#D2D8DF"
                strokeWidth="2.921"
                strokeLinecap="round"
              />
              <path
                id="Stroke 40"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M595.873 862.009C589.439 864.457 582.239 861.224 579.792 854.792C577.344 848.356 580.574 841.152 587.01 838.706C593.44 836.258 600.64 839.488 603.088 845.924C605.538 852.359 602.306 859.561 595.873 862.009Z"
                stroke="#D2D8DF"
                strokeWidth="2.921"
                strokeLinecap="round"
              />
            </g>
          </g>
          <g id="search">
            <g id="documents">
              <path
                id="Fill 1"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M592.038 624H346.024C328.708 624 314.534 609.784 314.534 592.41V241.582C314.534 224.209 328.708 210 346.024 210H592.038C609.36 210 623.534 224.209 623.534 241.582V592.41C623.534 609.784 609.36 624 592.038 624Z"
                fill="#E0E2EE"
              />
              <path
                id="Fill 3"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M571.038 639H325.024C307.708 639 293.534 624.784 293.534 607.41V256.582C293.534 239.209 307.708 225 325.024 225H571.038C588.36 225 602.534 239.209 602.534 256.582V607.41C602.534 624.784 588.36 639 571.038 639Z"
                fill="#E8EBF2"
              />
              <path
                id="Fill 5"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M550.611 650.842H304.089C286.737 650.842 272.534 636.685 272.534 619.383V270.008C272.534 252.706 286.737 238.556 304.089 238.556H550.611C567.97 238.556 582.173 252.706 582.173 270.008V619.383C582.173 636.685 567.97 650.842 550.611 650.842Z"
                fill="#D8DBEA"
              />
              <path
                id="Fill 8"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M550.611 650.842H304.089C286.737 650.842 272.534 636.685 272.534 619.383V270.008C272.534 252.706 286.737 238.556 304.089 238.556H550.611C567.97 238.556 582.173 252.706 582.173 270.008V619.383C582.173 636.685 567.97 650.842 550.611 650.842Z"
                fill="#F1F2F7"
              />
              <path
                id="Fill 11"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M515.078 345H332.991C327.791 345 323.534 340.951 323.534 336.003C323.534 331.049 327.791 327 332.991 327H515.078C520.278 327 524.534 331.049 524.534 336.003C524.534 340.951 520.278 345 515.078 345Z"
                fill="#E0E2EE"
              />
              <path
                id="Fill 13"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M515.078 399H332.991C327.791 399 323.534 394.951 323.534 390.003C323.534 385.049 327.791 381 332.991 381H515.078C520.278 381 524.534 385.049 524.534 390.003C524.534 394.951 520.278 399 515.078 399Z"
                fill="#E0E2EE"
              />
              <path
                id="Fill 15"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M515.078 453H332.991C327.791 453 323.534 448.951 323.534 444.003C323.534 439.056 327.791 435 332.991 435H515.078C520.278 435 524.534 439.056 524.534 444.003C524.534 448.951 520.278 453 515.078 453Z"
                fill="#E0E2EE"
              />
              <path
                id="Fill 17"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M515.078 507H332.991C327.791 507 323.534 502.951 323.534 498.003C323.534 493.049 327.791 489 332.991 489H515.078C520.278 489 524.534 493.049 524.534 498.003C524.534 502.951 520.278 507 515.078 507Z"
                fill="#E0E2EE"
              />
              <path
                id="Fill 19"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M428.037 561H333.031C327.809 561 323.534 556.951 323.534 552.003C323.534 547.049 327.809 543 333.031 543H428.037C433.259 543 437.534 547.049 437.534 552.003C437.534 556.951 433.259 561 428.037 561Z"
                fill="#E0E2EE"
              />
            </g>
            <g id="search_2">
              <path
                id="Fill 21"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M619.799 491.21C583.389 527.614 527.022 531.721 486.099 503.615C480.87 499.958 475.892 495.851 471.25 491.21C468.86 488.829 466.608 486.371 464.485 483.783C460.241 478.615 456.522 473.104 453.476 467.409C448.109 457.791 444.459 447.585 442.467 437.036C436.038 403.952 445.651 368.342 471.25 342.755C496.91 317.091 532.526 307.542 565.615 313.908C576.159 315.962 586.374 319.61 595.994 324.916C601.697 328.03 607.133 331.748 612.309 335.992C614.89 338.106 617.348 340.366 619.73 342.755C624.38 347.396 628.548 352.366 632.137 357.602C660.256 398.51 656.14 454.875 619.799 491.21Z"
                fill="white"
                fillOpacity="0.1"
              />
              <path
                id="Fill 23"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M609.611 484.041C571.731 521.927 510.344 521.92 472.457 484.041C434.619 446.203 434.619 384.809 472.506 346.929C510.344 309.091 571.731 309.091 609.568 346.929C647.448 384.809 647.448 446.203 609.611 484.041ZM629.051 327.467C580.429 278.844 501.639 278.844 453.017 327.467C404.402 376.082 404.359 454.921 452.974 503.543C497.226 547.781 566.585 551.771 615.369 515.449C620.134 511.896 624.723 507.914 629.1 503.543C633.471 499.166 637.453 494.577 640.999 489.813C677.321 441.021 673.296 371.711 629.051 327.467Z"
                fill="#E0E2EE"
              />
              <path
                id="Fill 25"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M820.4 686.825L818.359 688.866C804.854 702.378 782.74 702.378 769.229 688.866L644.534 564.172L695.706 513L820.4 637.694C833.912 651.206 833.912 673.313 820.4 686.825Z"
                fill="#4062FF"
              />
              <path
                id="Fill 27"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M643.686 486L680.534 522.848L654.375 549L617.534 512.152C622.396 508.527 627.072 504.463 631.545 500.004C636.005 495.545 640.069 490.862 643.686 486Z"
                fill="#E0E2EE"
              />
              <path
                id="Fill 29"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M818.534 636.161L767.688 687L758.534 677.839L809.373 627L818.534 636.161Z"
                fill="#D9E0FF"
              />
              <path
                id="Fill 31"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M698.534 514.76L646.296 567L638.534 559.24L690.773 507L698.534 514.76Z"
                fill="#D9E0FF"
              />
              <path
                id="Fill 33"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M584.534 333.896L456.424 462C451.599 453.353 448.319 444.178 446.534 434.694L557.227 324C566.704 325.853 575.887 329.126 584.534 333.896Z"
                fill="white"
                fillOpacity="0.5"
              />
              <path
                id="Fill 35"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M626.534 364.345L488.033 495C483.073 491.735 478.352 488.06 473.949 483.907C471.683 481.769 469.54 479.576 467.534 477.26L607.723 345C610.177 346.899 612.509 348.921 614.768 351.059C619.17 355.212 623.131 359.659 626.534 364.345Z"
                fill="white"
                fillOpacity="0.5"
              />
            </g>
          </g>
        </g>
      </svg>

      <p className="text-text-black text-xl font-semibold leading-[30px]">
        No results to show
      </p>
    </div>
  );
};
export default NoDataShown;
